import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import Chart from 'react-apexcharts'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import { Card, Text } from 'components/Library'
import { colors } from 'components/Library/theme'
import { CANTIDAD_MESES_GRAFICO } from 'utils/constants'
import { formatearTiempo } from 'utils/formatters'

dayjs.extend(customParseFormat)
const AvgTime = () => {
  const { globalAnalytics } = useSelector((state) => state.analytics)
  const [tiempoPromedio, setTiempoPromedio] = useState(0)
  const [datosGrafico, setDatosGrafico] = useState([])
  // TODO: default datos grafico con meses en 0
  useEffect(() => {
    // Dato total
    if (globalAnalytics[0] && globalAnalytics[0].rowCount > 0) {
      const tiempoFormateado = formatearTiempo(globalAnalytics[0].rows[0].metricValues[2].value) // averageSessionDuration
      setTiempoPromedio(tiempoFormateado)
    }

    // Dato meses
    if (globalAnalytics[1] && globalAnalytics[1].rowCount > 0) {
      // Armar arreglo últimos 6 meses
      const ultimosMeses = []
      const fechaTemporal = new Date()
      for (let i = 0; i < CANTIDAD_MESES_GRAFICO; i++) {
        const mesFormateado = dayjs(fechaTemporal).format('MMM YYYY') // Formatear mes de la iteración actual
        ultimosMeses.unshift({ mes: mesFormateado, valor: 0 }) // Añadir mes al principio del arreglo
        fechaTemporal.setMonth(fechaTemporal.getMonth() - 1) // Restar 1 mes
      }

      globalAnalytics[1].rows.forEach((analytic) => {
        // Obtener los valores de la iteración actual y formatearlos
        const anioMes = analytic.dimensionValues[0].value
        const mesFormateado = dayjs(anioMes, 'YYYYMM').format('MMM YYYY')
        const valor = analytic.metricValues[2].value // averageSessionDuration
        // Encontrar el index de ultimosMeses igual al mesFormateado para asignar el valor
        const index = ultimosMeses.findIndex((item) => item.mes === mesFormateado)
        if (index !== -1) ultimosMeses[index].valor = +valor
      })
      setDatosGrafico(ultimosMeses)
    }
  }, [globalAnalytics])

  return (
    <Card style={{ width: '100%' }}>
      <div
        style={{
          padding: '2rem 2rem 0 2rem'
        }}
      >
        <Text
          color={colors.error}
          weight="bold"
          style={{
            fontSize: '1.5rem'
          }}
        >
          {tiempoPromedio}
        </Text>
        <Text size="large" color={colors.error}>
          Tiempo promedio
        </Text>
      </div>

      <Chart
        options={{
          chart: {
            toolbar: {
              show: false
            }
          },
          colors: [colors.error],
          xaxis: {
            labels: {
              show: false
            },
            axisTicks: {
              show: false
            },
            categories: datosGrafico.map((item) => item.mes)
          },
          yaxis: {
            show: false
          },
          dataLabels: {
            enabled: false
          },
          tooltip: {
            y: {
              formatter: formatearTiempo
            }
          },
          grid: {
            show: false,
            padding: {
              top: 0,
              right: 0,
              bottom: -15,
              left: 0
            }
          }
        }}
        series={[
          {
            name: 'Tiempo promedio',
            data: datosGrafico.map((item) => item.valor)
          }
        ]}
        height={100}
        type="area"
        toolbar={{
          show: false
        }}
      />
    </Card>
  )
}

export default AvgTime
